import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal';
import { useSelector } from 'react-redux';
import Button from "../../../components/common/button/Button"
import LoadingComponent from "../../../components/loading/LoadingComponent"
import callApi from '../../../services/api/apiClient';
import styled from './CustomerDetail.module.css'
import CustomerCreate from '../customer_create/CustomerCreate';
import CustomerEdit from '../customer_edit/CustomerEdit';


const CustomerDetail = ({ isOpen, onClose, item ,setShowDetail, getCustomerList}) => {
    const customerDetail = useSelector(state => state?.customer?.customerDetail?.data);

    const [isEdit , setIsEdit] = useState(false)

    console.log("item...", customerDetail)

    useEffect(() => {
        getCustomerDetail()
    }, [item])

    const getCustomerDetail = () => {
        callApi("customer/customerDetail")
            .withKeyParameter({ id: item?.id })
            .loadingGroup("customerDetail")
            .executeDispatch();
    }
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            className='flex items-center justify-center'
        >
            <LoadingComponent loadingGroup={"customerDetail"}>
                <div className={styled.detail_container}>
                    <p className={styled.title}>Customer Detail</p>

                    <div className={styled.customer_detail}>
                        <div className={styled.row_container}>
                            <label className={styled.label}>Name</label>
                            <p className={styled.value}>{customerDetail?.name}</p>
                        </div>
                        <div className={styled.row_container}>
                            <label className={styled.label}>Code</label>
                            <p className={styled.value}>{customerDetail?.code}</p>
                        </div>
                        <div className={styled.row_container}>
                            <label className={styled.label}>Phone</label>
                            <p className={styled.value}>{customerDetail?.mobile}</p>
                        </div>
                        <div className={styled.row_container}>
                            <label className={styled.label}>Locaton</label>
                            <div className='text-base font-interRegular text-black-0 flex-wrap'>
                                {
                                    customerDetail?.street && <p>{customerDetail?.street},</p>
                                }
                                {
                                    customerDetail?.township?.name && <p>{customerDetail?.township?.name} Township,</p>
                                }
                                {
                                    customerDetail?.state?.name && <p>{customerDetail?.state?.name}</p>
                                }
                            </div>

                        </div>

                    </div>
                    <Button className={styled.button} onClick={() => {
                        setIsEdit(true)
                        // onClose()
                        }}>
                        Edit
                    </Button>
                </div>
            <CustomerEdit
                isOpen={isEdit}
                onClose={() => {
                    setIsEdit(false)
                    onClose()
                    getCustomerList()
                }}
                data = {customerDetail}
                idEdit = {true}
                customer_id = {item?.id}
                getCustomerList={() => setShowDetail(true)}
            />
            </LoadingComponent>


        </Modal>
    )
}
export default CustomerDetail